export { default } from "./CardVertical"
